import React, { useEffect, useState } from "react";
import { GlygenTable } from "../components/GlygenTable";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { head, getMeta } from "../utils/head";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import { Card } from "react-bootstrap";
import { PageHeading } from "../components/FormControls";
import { Button } from "react-bootstrap";
import FeedbackWidget from "../components/FeedbackWidget";
import { exportFileMetadata } from "../utils/commonUtils";

const Spots = props => {
  useEffect(props.authCheckAgent, []);
  const [showSpinner, setShowSpinner] = useState(false);
  return (
    <>
      <Helmet>
        <title>{head.spots.title}</title>
        {getMeta(head.spots)}
      </Helmet>
      <FeedbackWidget />
      <Container maxWidth="xl">
        <div className="page-container">
          <PageHeading
            title="Your Spot Metadata"
            subTitle="The table below displays a list of all spot metadata that have been uploaded to your repository. New spots may be added, old spots can be edited, and unused spots can be removed."
          />
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <Link to="/spots/addSpot">
                  <Button className="gg-btn-blue mt-2">Add Spot Metadata</Button>
                </Link>
                <Link
                  to={{
                    pathname: "/spots/importFromFile",
                    state: {
                      templateType: "SPOT"
                    },
                  }}
                >
                  <Button className="gg-btn-blue mt-2 gg-ml-20">Add Metadata from file</Button>
                </Link>
              </div>

              <GlygenTable
                columns={[
                  {
                    Header: "Name",
                    accessor: "name"
                  }
                ]}
                defaultPageSize={10}
                defaultSortColumn="id"
                showCommentsButton
                showDeleteButton
                showEditButton
                showCopyButton
                showSearchBox
                showMirageCompliance
                commentsRefColumn="description"
                exportData
                exportWsCall={"contributeexportmetadata"}
                templateType={"SPOT"}
                fileName={"exportspotmetadata"}
                fetchWS="listspotmetadata"
                deleteWS="deletespotmetadata"
                editUrl="spots/editSpot"
                copyUrl="spots/copySpot"
                copyPage="copySpot"
                keyColumn="id"
                form={"metadata"}
                showRowsInfo
                infoRowsText="Spot Metadata"
                showExport
                setShowSpinner={setShowSpinner}
                handleExport={exportFileMetadata}
                exportTitle={"Export metadata to file"}
              />
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  );
};

Spots.propTypes = { authCheckAgent: PropTypes.func };

export { Spots };
